export enum EducationStatusEnum {
	ACTIVE = 'active',
	PASSIVE = 'passive',
	CORRESPONDENT = 'correspondent',
	DISTANCE_LEARNING = 'distance_learning',
}
